$(document).ready(function(){

  // Movimiento ShopPay.
  
  $( ".product-block.product-block--price" ).append("<div class='container-shoppay-price'></div>");
  $( ".container-shoppay-price" ).append( $( ".shopify-payment-terms.product__policies" ));
  
  
  // Dropdown Description.
  
  $('.description-product__accordion-list > li').first().addClass('active_description');
  $('.description-product__accordion-list > li > .description-product__answer').hide();
  $('.description-product__accordion-list > li.active_description > .description-product__answer').show();
  $('.description-product__accordion-list > li > h3').click(function() {
    var $open_description = $(this).parents('li');
    if ($($open_description).hasClass("active_description")) {
      $($open_description).removeClass("active_description").find(".description-product__answer").slideUp();
    } else {
      $(".description-product__accordion-list > li.active_description .description-product__answer").slideUp();
      $(".description-product__accordion-list > li.active_description").removeClass("active_description");
      $($open_description).addClass("active_description").find(".description-product__answer").slideDown();
    }
    return false;
  });  

});



"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);
window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
  subscribe('appLoad', function(event) {
    console.log('appLoad', event);
    activarLabelSeleccionado();
  });

  subscribe('fieldChange', function(event) {
    console.log('fieldChange', event);
    activarLabelSeleccionado();
  });

  function activarLabelSeleccionado() {
    const $labels = $('div#infiniteoptions-container div[aria-labelledby*="Colors"] > span > label');
    $labels.removeClass('active-label');
    $labels.has('input[type="radio"]:checked').addClass('active-label');
  }
};